export const DEFAULT_AUDIO_VOICE = 'marin';

export const AUDIO_VOICE_OPTIONS = [
  { value: 'marin', label: 'Marin (padrão)' },
  { value: 'cedar', label: 'Cedar' },
  { value: 'alloy', label: 'Alloy' },
  { value: 'ash', label: 'Ash' },
  { value: 'ballad', label: 'Ballad' },
  { value: 'coral', label: 'Coral' },
  { value: 'echo', label: 'Echo' },
  { value: 'fable', label: 'Fable' },
  { value: 'nova', label: 'Nova' },
  { value: 'onyx', label: 'Onyx' },
  { value: 'sage', label: 'Sage' },
  { value: 'shimmer', label: 'Shimmer' },
  { value: 'verse', label: 'Verse' },
];

export const normalizeAudioVoice = value =>
  AUDIO_VOICE_OPTIONS.some(option => option.value === value)
    ? value
    : DEFAULT_AUDIO_VOICE;

// Amostras estáticas geradas por script/generate_ai_voice_samples.py: ouvir uma
// voz nunca chama a OpenAI.
export const audioVoiceSampleUrl = value =>
  `/audio/ai_voices/${normalizeAudioVoice(value)}.mp3`;

export const AUDIO_ENABLED_OPTIONS = [
  { value: false, label: 'Não' },
  { value: true, label: 'Sim' },
];
export const normalizeAudioEnabled = value => value === true;
